import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Label,
    Button
} from "reactstrap"
import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'
import { Preview } from '../../../../helpers/ui/FileInput'
import { Redirect, Link } from "react-router-dom"
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar"

import AwardBloc from '../Index/Blocs/AwardBloc'

class DetailView extends Component {

    source
    awardBloc = new AwardBloc()

    constructor(props) {
        super(props)
        this.state = {
            award: [],
            detail: []
        }
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id
        }
        await this.awardBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.awardBloc.detailChannel.subscribe((result) => {
            console.log('cek', result)
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.awardBloc.detailChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col xs="12">
                            <PegawaiSideBar active="penghargaan" />

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Data Penghargaan</CardTitle>
                                    <hr/>
                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">Jenis Penghargaan</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.type?.type_of_award_name}</Label>
                                        
                                        <Label className="col-md-3 col-form-label">Nama Penghargaan</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_title}</Label>
                                        
                                        <Label className="col-md-3 col-form-label">Tahun</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_year}</Label>

                                        <Label className="col-md-3 col-form-label">No Kepres</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_decree_number}</Label>

                                        <Label className="col-md-3 col-form-label">Tanggal Kepres</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_decree_date}</Label>

                                        <Label className="col-md-3 col-form-label">Pejabat Penetap</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_signatories_official}</Label>
                                        
                                        <Label className="col-md-3 col-form-label">Deskripsi</Label>
                                        <Label className="col-md-9 col-form-label">{detail?.award_description}</Label>

                                        <Label className="col-md-3 col-form-label">Dokumen Pendukung</Label>
                                        <Label className="col-md-9 col-form-label">
                                            <Preview value={detail?.document} />
                                        </Label>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="4"></Col>
                                        <Col md="8">
                                            <Link to="/kepegawaian/home.html?penghargaan">
                                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default DetailView;